/**
 * Uses Splide package to create a carousel for product media
 * More info: https://splidejs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector("[data-slider]");
    this.sliderIndex = this.querySelector("[data-index-text");
    this.slider = null;
    this.selectedMediaIndex =
      Number(
        this.sliderElement.querySelector("[data-selected]")?.dataset.index
      ) || 0;
    this.options = {
      type: "loop",
      mediaQuery: "min",
      start: this.selectedMediaIndex,
      waitForTransition: false,
      gap: "0.5rem",
      padding: {
        left: "1.6rem",
        right: "1.6rem",
      },
      pagination: false,
      arrows: true,
      infinite: true,
      breakpoints: {
        750: {
          destroy: true,
        },
      },
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.sliderElement) return;

    this.slider = new Splide(this.sliderElement, this.options);
    this.slider.on("move", this.updateActiveIndex.bind(this));
    this.slider.mount();
  }

  updateActiveIndex() {
    this.sliderIndex.innerHTML =
      this.slider.Components.Controller.getIndex() + 1;
  }

  setActiveMedia(id) {
    const mediaFound = this.slider.Components.Elements.slides.find(
      (slide) => Number(slide.dataset.mediaId) === id
    );
    if (!mediaFound) return;
    this.slider.go(Number(mediaFound.dataset.index));
  }
}

customElements.define("product-media", ProductMedia);
